import { action, Action } from "easy-peasy";



export interface IGlobalErrorReport {
  showGlobalReport?: boolean;
  showOpenButton?: boolean;
  messageDescription?: string;
  errorRef?: string;
  /**
   * Prefills for a report that isn't a connection error (e.g. a renewal request). When set, the
   * report form uses them as-is instead of its connection-error defaults.
   */
  topic?: number;
  subject?: string;
  description?: string;
}

export interface IMessagesModel {
  message: any;
  /**An object to show the reportProblem on connection error */
  globalErrorReport: IGlobalErrorReport;
  setGlobalErrorReport: Action<IMessagesModel, IGlobalErrorReport>;
  addMessage: Action<IMessagesModel, any>;
  hideMessage: Action<IMessagesModel, any>;
}

export const messageModel: IMessagesModel = {
  message: {
    message: ""
  },
  /**An object to show the reportProblem on connection error */
  globalErrorReport:{
    showGlobalReport:false,
    showOpenButton:false,
    messageDescription:'',
  },
  setGlobalErrorReport:action((state,payload)=>{
    state.globalErrorReport = payload
  }),

  addMessage: action((state, payload) => {
    state.message = { ...payload };
  }),
  hideMessage: action((state, cb) => {
    state.message.message = "";
    if (cb) {
      cb();
    }
  })
};
